(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('billboard.js'), require('react'), require('prop-types')) :
  typeof define === 'function' && define.amd ? define(['exports', 'billboard.js', 'react', 'prop-types'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global['react-billboardjs'] = {}, global.billboard, global.React, global.PropTypes));
}(this, (function (exports, billboard_js, React, PropTypes) { 'use strict';

  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

  var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
  var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  // external dependencies
  var AREA_SHAPE = PropTypes__default['default'].shape({
    above: PropTypes__default['default'].bool,
    zerobased: PropTypes__default['default'].bool
  });
  var LABEL_SHAPE = PropTypes__default['default'].oneOfType([PropTypes__default['default'].shape({
    position: PropTypes__default['default'].oneOf(['inner-bottom', 'inner-center', 'inner-left', 'inner-middle', 'inner-right', 'inner-top', 'outer-bottom', 'outer-center', 'outer-left', 'outer-middle', 'outer-right', 'outer-top']),
    text: PropTypes__default['default'].string
  }), PropTypes__default['default'].string]);
  var AXIS_TYPE_SHAPE = PropTypes__default['default'].oneOf(['category', 'indexed', 'timeseries']);
  var AXIS_Y_PADDING_SHAPE = PropTypes__default['default'].shape({
    bottom: PropTypes__default['default'].number,
    top: PropTypes__default['default'].number
  });
  var AXIS_TICK_SHAPE = PropTypes__default['default'].shape({
    count: PropTypes__default['default'].number,
    format: PropTypes__default['default'].func,
    text: PropTypes__default['default'].shape({
      position: PropTypes__default['default'].shape({
        x: PropTypes__default['default'].number,
        y: PropTypes__default['default'].number
      })
    }),
    values: PropTypes__default['default'].arrayOf(PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].instanceOf(Date)]))
  });
  var AXIS_SHAPE = PropTypes__default['default'].shape({
    rotated: PropTypes__default['default'].bool,
    x: PropTypes__default['default'].shape({
      categories: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string),
      clipPath: PropTypes__default['default'].bool,
      extent: PropTypes__default['default'].arrayOf(PropTypes__default['default'].arrayOf(PropTypes__default['default'].number)),
      height: PropTypes__default['default'].number,
      label: LABEL_SHAPE,
      localtime: PropTypes__default['default'].bool,
      max: PropTypes__default['default'].number,
      min: PropTypes__default['default'].number,
      padding: PropTypes__default['default'].shape({
        left: PropTypes__default['default'].number,
        right: PropTypes__default['default'].number
      }),
      show: PropTypes__default['default'].bool,
      tick: PropTypes__default['default'].shape({
        centered: PropTypes__default['default'].bool,
        count: PropTypes__default['default'].number,
        culling: PropTypes__default['default'].oneOfType([PropTypes__default['default'].bool, PropTypes__default['default'].shape({
          max: PropTypes__default['default'].number
        })]),
        fit: PropTypes__default['default'].bool,
        format: PropTypes__default['default'].oneOfType([PropTypes__default['default'].func, PropTypes__default['default'].string]),
        multiline: PropTypes__default['default'].bool,
        outer: PropTypes__default['default'].bool,
        rotate: PropTypes__default['default'].number,
        tooltip: PropTypes__default['default'].bool,
        values: PropTypes__default['default'].arrayOf(PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].instanceOf(Date)])),
        width: PropTypes__default['default'].number
      }),
      type: AXIS_TYPE_SHAPE
    }),
    y: PropTypes__default['default'].shape({
      center: PropTypes__default['default'].number,
      default: PropTypes__default['default'].arrayOf(PropTypes__default['default'].number),
      format: PropTypes__default['default'].func,
      inner: PropTypes__default['default'].bool,
      inverted: PropTypes__default['default'].bool,
      label: LABEL_SHAPE,
      max: PropTypes__default['default'].number,
      min: PropTypes__default['default'].number,
      padding: AXIS_Y_PADDING_SHAPE,
      show: PropTypes__default['default'].bool,
      tick: AXIS_TICK_SHAPE,
      type: AXIS_TYPE_SHAPE
    }),
    y2: PropTypes__default['default'].shape({
      center: PropTypes__default['default'].number,
      default: PropTypes__default['default'].arrayOf(PropTypes__default['default'].number),
      inner: PropTypes__default['default'].bool,
      inverted: PropTypes__default['default'].bool,
      label: LABEL_SHAPE,
      max: PropTypes__default['default'].number,
      min: PropTypes__default['default'].number,
      padding: AXIS_Y_PADDING_SHAPE,
      show: PropTypes__default['default'].bool,
      tick: AXIS_TICK_SHAPE
    })
  });
  var BAR_SHAPE = PropTypes__default['default'].shape({
    padding: PropTypes__default['default'].number,
    radius: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].shape({
      ratio: PropTypes__default['default'].number
    })]),
    width: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].shape({
      max: PropTypes__default['default'].number,
      ratio: PropTypes__default['default'].number
    })]),
    zerobased: PropTypes__default['default'].bool
  });
  var COLOR_SHAPE = PropTypes__default['default'].shape({
    pattern: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string),
    threshold: PropTypes__default['default'].shape({
      max: PropTypes__default['default'].number,
      unit: PropTypes__default['default'].string,
      value: PropTypes__default['default'].string
    })
  });
  var LINE_SHAPE = PropTypes__default['default'].shape({
    classes: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string),
    connectNull: PropTypes__default['default'].bool,
    point: PropTypes__default['default'].oneOf([PropTypes__default['default'].arrayOf(PropTypes__default['default'].string), PropTypes__default['default'].bool]),
    step: PropTypes__default['default'].shape({
      type: PropTypes__default['default'].oneOf(['step', 'step-after', 'step-before'])
    })
  });
  var ORDER_SHAPE = PropTypes__default['default'].oneOfType([PropTypes__default['default'].func, PropTypes__default['default'].oneOf(['asc', 'desc', '', null])]);
  var DATA_SHAPE = PropTypes__default['default'].shape({
    axes: PropTypes__default['default'].object,
    classes: PropTypes__default['default'].object,
    color: PropTypes__default['default'].oneOfType([PropTypes__default['default'].func, PropTypes__default['default'].shape({
      pattern: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string),
      tiles: PropTypes__default['default'].func
    })]),
    colors: PropTypes__default['default'].object,
    columns: PropTypes__default['default'].arrayOf(PropTypes__default['default'].arrayOf(PropTypes__default['default'].oneOfType([PropTypes__default['default'].arrayOf(PropTypes__default['default'].number), PropTypes__default['default'].number, PropTypes__default['default'].shape({
      height: PropTypes__default['default'].number,
      low: PropTypes__default['default'].number,
      mid: PropTypes__default['default'].number
    }), PropTypes__default['default'].string]))),
    empty: PropTypes__default['default'].shape({
      label: LABEL_SHAPE
    }),
    groups: PropTypes__default['default'].arrayOf(PropTypes__default['default'].oneOfType([PropTypes__default['default'].arrayOf(PropTypes__default['default'].string), PropTypes__default['default'].string])),
    hide: PropTypes__default['default'].oneOfType([PropTypes__default['default'].bool, PropTypes__default['default'].arrayOf(PropTypes__default['default'].string)]),
    json: PropTypes__default['default'].oneOfType([PropTypes__default['default'].arrayOf(PropTypes__default['default'].object), PropTypes__default['default'].object]),
    keys: PropTypes__default['default'].shape({
      value: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string),
      x: PropTypes__default['default'].oneOfType([PropTypes__default['default'].arrayOf(PropTypes__default['default'].string), PropTypes__default['default'].string]),
      y: PropTypes__default['default'].oneOfType([PropTypes__default['default'].arrayOf(PropTypes__default['default'].string), PropTypes__default['default'].string]),
      y2: PropTypes__default['default'].oneOfType([PropTypes__default['default'].arrayOf(PropTypes__default['default'].string), PropTypes__default['default'].string])
    }),
    labels: PropTypes__default['default'].oneOfType([PropTypes__default['default'].bool, PropTypes__default['default'].shape({
      format: PropTypes__default['default'].func,
      position: PropTypes__default['default'].shape({
        x: PropTypes__default['default'].number,
        y: PropTypes__default['default'].number
      })
    })]),
    line: LINE_SHAPE,
    mimeType: PropTypes__default['default'].string,
    names: PropTypes__default['default'].object,
    onclick: PropTypes__default['default'].func,
    onmax: PropTypes__default['default'].func,
    onmin: PropTypes__default['default'].func,
    onout: PropTypes__default['default'].func,
    onover: PropTypes__default['default'].func,
    onselected: PropTypes__default['default'].func,
    onunselected: PropTypes__default['default'].func,
    order: ORDER_SHAPE,
    point: PropTypes__default['default'].shape({
      focus: PropTypes__default['default'].shape({
        expand: PropTypes__default['default'].shape({
          enabled: PropTypes__default['default'].bool,
          r: PropTypes__default['default'].oneOfType([PropTypes__default['default'].bool, PropTypes__default['default'].number])
        })
      }),
      pattern: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string),
      r: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].func]),
      select: PropTypes__default['default'].shape({
        r: PropTypes__default['default'].number
      }),
      show: PropTypes__default['default'].bool,
      type: PropTypes__default['default'].oneOf(['circle', 'rectangle'])
    }),
    regions: PropTypes__default['default'].object,
    rows: PropTypes__default['default'].arrayOf(PropTypes__default['default'].arrayOf(PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].string]))),
    selection: PropTypes__default['default'].shape({
      draggable: PropTypes__default['default'].bool,
      enabled: PropTypes__default['default'].bool,
      isselectable: PropTypes__default['default'].bool,
      multiple: PropTypes__default['default'].bool
    }),
    type: PropTypes__default['default'].oneOf(['area', 'area-line-range', 'area-range', 'area-spline', 'area-step', 'bar', 'bubble', 'donut', 'gauge', 'line', 'pie', 'radar', 'scatter', 'spline']),
    types: PropTypes__default['default'].object,
    url: PropTypes__default['default'].string,
    x: PropTypes__default['default'].string,
    xFormat: PropTypes__default['default'].string,
    xLocaltime: PropTypes__default['default'].bool,
    xSort: PropTypes__default['default'].bool,
    xs: PropTypes__default['default'].object
  });
  var DONUT_SHAPE = PropTypes__default['default'].shape({
    expand: PropTypes__default['default'].bool,
    label: PropTypes__default['default'].shape({
      format: PropTypes__default['default'].func,
      radio: PropTypes__default['default'].oneOfType([PropTypes__default['default'].func, PropTypes__default['default'].number]),
      show: PropTypes__default['default'].bool,
      threshold: PropTypes__default['default'].number
    }),
    padAngle: PropTypes__default['default'].number,
    title: PropTypes__default['default'].string,
    width: PropTypes__default['default'].number
  });
  var GAUGE_SHAPE = PropTypes__default['default'].shape({
    expand: PropTypes__default['default'].oneOfType([PropTypes__default['default'].bool, PropTypes__default['default'].shape({
      duration: PropTypes__default['default'].number
    })]),
    fullCircle: PropTypes__default['default'].bool,
    label: PropTypes__default['default'].shape({
      extents: PropTypes__default['default'].func,
      format: PropTypes__default['default'].func,
      show: PropTypes__default['default'].bool
    }),
    max: PropTypes__default['default'].number,
    startingAngle: PropTypes__default['default'].number,
    units: PropTypes__default['default'].string,
    width: PropTypes__default['default'].number
  });
  var LINES_SHAPE = PropTypes__default['default'].oneOfType([PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape({
    class: PropTypes__default['default'].string,
    position: PropTypes__default['default'].string,
    text: PropTypes__default['default'].string,
    value: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].string, PropTypes__default['default'].instanceOf(Date)])
  })), PropTypes__default['default'].bool]);
  var GRID_SHAPE = PropTypes__default['default'].shape({
    focus: PropTypes__default['default'].shape({
      show: PropTypes__default['default'].bool
    }),
    lines: PropTypes__default['default'].shape({
      front: PropTypes__default['default'].bool
    }),
    x: PropTypes__default['default'].shape({
      lines: LINES_SHAPE,
      show: PropTypes__default['default'].bool
    }),
    y: PropTypes__default['default'].shape({
      lines: LINES_SHAPE,
      show: PropTypes__default['default'].bool,
      ticks: PropTypes__default['default'].oneOfType([PropTypes__default['default'].bool, PropTypes__default['default'].number])
    })
  });
  var INTERACTION_SHAPE = PropTypes__default['default'].shape({
    brighten: PropTypes__default['default'].bool,
    enabled: PropTypes__default['default'].bool,
    inputType: PropTypes__default['default'].shape({
      mouse: PropTypes__default['default'].bool,
      touch: PropTypes__default['default'].oneOfType([PropTypes__default['default'].bool, PropTypes__default['default'].shape({
        preventDefault: PropTypes__default['default'].oneOfType([PropTypes__default['default'].bool, PropTypes__default['default'].number])
      })])
    })
  });
  var LEGEND_SHAPE = PropTypes__default['default'].shape({
    contents: PropTypes__default['default'].shape({
      bindto: PropTypes__default['default'].oneOfType([PropTypes__default['default'].object, PropTypes__default['default'].string]),
      template: PropTypes__default['default'].oneOfType([PropTypes__default['default'].func, PropTypes__default['default'].string])
    }),
    equally: PropTypes__default['default'].bool,
    hide: PropTypes__default['default'].bool,
    inset: PropTypes__default['default'].shape({
      anchor: PropTypes__default['default'].oneOf(['bottom-left', 'bottom-right', 'top-left', 'top-right']),
      step: PropTypes__default['default'].number,
      x: PropTypes__default['default'].number,
      y: PropTypes__default['default'].number
    }),
    item: PropTypes__default['default'].shape({
      onclick: PropTypes__default['default'].func,
      onout: PropTypes__default['default'].func,
      onover: PropTypes__default['default'].func,
      tile: PropTypes__default['default'].shape({
        height: PropTypes__default['default'].number,
        width: PropTypes__default['default'].number
      })
    }),
    padding: PropTypes__default['default'].number,
    position: PropTypes__default['default'].oneOf(['bottom', 'right', 'inset']),
    show: PropTypes__default['default'].bool,
    usePoint: PropTypes__default['default'].bool
  });
  var PADDING_SHAPE = PropTypes__default['default'].shape({
    bottom: PropTypes__default['default'].number,
    left: PropTypes__default['default'].number,
    right: PropTypes__default['default'].number,
    top: PropTypes__default['default'].number
  });
  var PIE_SHAPE = PropTypes__default['default'].shape({
    expand: PropTypes__default['default'].bool,
    innerRadius: PropTypes__default['default'].number,
    label: PropTypes__default['default'].shape({
      format: PropTypes__default['default'].func,
      ratio: PropTypes__default['default'].number,
      show: PropTypes__default['default'].bool,
      threshold: PropTypes__default['default'].number
    }),
    padAngle: PropTypes__default['default'].number,
    padding: PropTypes__default['default'].number
  });
  var POINT_SHAPE = PropTypes__default['default'].shape({
    focus: PropTypes__default['default'].shape({
      expand: PropTypes__default['default'].shape({
        enabled: PropTypes__default['default'].bool,
        r: PropTypes__default['default'].oneOfType([PropTypes__default['default'].bool, PropTypes__default['default'].number])
      })
    }),
    r: PropTypes__default['default'].number,
    select: PropTypes__default['default'].shape({
      r: PropTypes__default['default'].number
    }),
    show: PropTypes__default['default'].bool
  });
  var RADAR_SHAPE = PropTypes__default['default'].shape({
    axis: PropTypes__default['default'].shape({
      line: PropTypes__default['default'].shape({
        show: PropTypes__default['default'].bool
      }),
      max: PropTypes__default['default'].number,
      text: PropTypes__default['default'].shape({
        show: PropTypes__default['default'].bool
      })
    }),
    direction: PropTypes__default['default'].shape({
      clockwise: PropTypes__default['default'].bool
    }),
    level: PropTypes__default['default'].shape({
      depth: PropTypes__default['default'].number,
      show: PropTypes__default['default'].bool,
      text: PropTypes__default['default'].shape({
        format: PropTypes__default['default'].func,
        show: PropTypes__default['default'].bool
      })
    }),
    size: PropTypes__default['default'].shape({
      ratio: PropTypes__default['default'].number
    })
  });
  var REGION_SHAPE = PropTypes__default['default'].shape({
    axis: PropTypes__default['default'].string,
    class: PropTypes__default['default'].string,
    end: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].string]),
    start: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].string]),
    style: PropTypes__default['default'].object
  });
  var RESIZE_SHAPE = PropTypes__default['default'].shape({
    auto: PropTypes__default['default'].bool
  });
  var SIZE_SHAPE = PropTypes__default['default'].shape({
    height: PropTypes__default['default'].number,
    width: PropTypes__default['default'].number
  });
  var SPLINE_SHAPE = PropTypes__default['default'].shape({
    interpolation: PropTypes__default['default'].shape({
      type: PropTypes__default['default'].string
    })
  });
  var SUBCHART_SHAPE = PropTypes__default['default'].shape({
    onbrush: PropTypes__default['default'].oneOfType([PropTypes__default['default'].bool, PropTypes__default['default'].func]),
    show: PropTypes__default['default'].bool,
    size: PropTypes__default['default'].shape({
      height: PropTypes__default['default'].number
    })
  });
  var SVG_SHAPE = PropTypes__default['default'].shape({
    className: PropTypes__default['default'].string
  });
  var TITLE_SHAPE = PropTypes__default['default'].shape({
    padding: PADDING_SHAPE,
    position: PropTypes__default['default'].oneOf(['bottom-center', 'bottom-left', 'bottom-right', 'top-center', 'top-left', 'top-right']),
    text: PropTypes__default['default'].string
  });
  var TOOLTIP_SHAPE = PropTypes__default['default'].shape({
    contents: PropTypes__default['default'].func,
    format: PropTypes__default['default'].shape({
      name: PropTypes__default['default'].func,
      title: PropTypes__default['default'].func,
      value: PropTypes__default['default'].func
    }),
    grouped: PropTypes__default['default'].bool,
    linked: PropTypes__default['default'].oneOfType([PropTypes__default['default'].bool, PropTypes__default['default'].shape({
      name: PropTypes__default['default'].string
    })]),
    order: ORDER_SHAPE,
    position: PropTypes__default['default'].func,
    show: PropTypes__default['default'].bool
  });
  var TRANSITION_SHAPE = PropTypes__default['default'].shape({
    duration: PropTypes__default['default'].number
  });
  var ZOOM_SHAPE = PropTypes__default['default'].shape({
    enabled: PropTypes__default['default'].oneOfType([PropTypes__default['default'].bool, PropTypes__default['default'].shape({
      type: PropTypes__default['default'].string
    })]),
    extent: PropTypes__default['default'].arrayOf(PropTypes__default['default'].number),
    onzoom: PropTypes__default['default'].func,
    onzoomend: PropTypes__default['default'].func,
    onzoomstart: PropTypes__default['default'].func,
    rescale: PropTypes__default['default'].bool,
    resetButton: PropTypes__default['default'].oneOfType([PropTypes__default['default'].bool, PropTypes__default['default'].shape({
      text: PropTypes__default['default'].string
    })]),
    x: PropTypes__default['default'].shape({
      max: PropTypes__default['default'].number,
      min: PropTypes__default['default'].number
    })
  });
  var propTypes = {
    area: AREA_SHAPE,
    axis: AXIS_SHAPE,
    bar: BAR_SHAPE,
    className: PropTypes__default['default'].string,
    clipPath: PropTypes__default['default'].bool,
    color: COLOR_SHAPE,
    data: DATA_SHAPE.isRequired,
    domProps: PropTypes__default['default'].object,
    donut: DONUT_SHAPE,
    gauge: GAUGE_SHAPE,
    grid: GRID_SHAPE,
    interaction: INTERACTION_SHAPE,
    isPure: PropTypes__default['default'].bool,
    legend: LEGEND_SHAPE,
    line: LINE_SHAPE,
    onafterinit: PropTypes__default['default'].func,
    onbeforeinit: PropTypes__default['default'].func,
    oninit: PropTypes__default['default'].func,
    onmouseout: PropTypes__default['default'].func,
    onmouseover: PropTypes__default['default'].func,
    onrendered: PropTypes__default['default'].func,
    onresize: PropTypes__default['default'].func,
    onresized: PropTypes__default['default'].func,
    padding: PADDING_SHAPE,
    pie: PIE_SHAPE,
    point: POINT_SHAPE,
    radar: RADAR_SHAPE,
    regions: PropTypes__default['default'].arrayOf(REGION_SHAPE),
    resize: RESIZE_SHAPE,
    size: SIZE_SHAPE,
    spline: SPLINE_SHAPE,
    style: PropTypes__default['default'].object,
    subchart: SUBCHART_SHAPE,
    svg: SVG_SHAPE,
    title: TITLE_SHAPE,
    tooltip: TOOLTIP_SHAPE,
    transition: TRANSITION_SHAPE,
    unloadBeforeLoad: PropTypes__default['default'].bool,
    zoom: ZOOM_SHAPE
  };

  function shallowEqual(a, b) {
    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);
    var length = aKeys.length;

    if (length !== bKeys.length) {
      return false;
    }

    var index = -1;

    while (++index < length) {
      var key = aKeys[index];

      if (key !== bKeys[index] || a[key] !== b[key]) {
        return false;
      }
    }

    return true;
  }

  var BillboardChart = /*#__PURE__*/function (_React$Component) {
    _inheritsLoose(BillboardChart, _React$Component);

    function BillboardChart(props) {
      var _this;

      _this = _React$Component.call(this, props) || this; // Explicit binds instead of arrow functions for lower memory footprint.

      _this.exportChart = _this.exportChart.bind(_assertThisInitialized(_this));
      _this.destroyChart = _this.destroyChart.bind(_assertThisInitialized(_this));
      _this.loadData = _this.loadData.bind(_assertThisInitialized(_this));
      _this.redraw = _this.redraw.bind(_assertThisInitialized(_this));
      _this.setChart = _this.setChart.bind(_assertThisInitialized(_this));
      _this.setChartElementRef = _this.setChartElementRef.bind(_assertThisInitialized(_this));
      _this.unloadData = _this.unloadData.bind(_assertThisInitialized(_this));
      _this.updateConfig = _this.updateConfig.bind(_assertThisInitialized(_this));
      return _this;
    }

    var _proto = BillboardChart.prototype;

    _proto.componentDidMount = function componentDidMount() {
      this.updateChart();
    };

    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
      return !nextProps.isPure || !shallowEqual(this.props, nextProps);
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.updateChart();
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.destroyChart();
    };

    _proto.destroyChart = function destroyChart() {
      if (this.chart) {
        this.chart.destroy();
      }

      this.chart = null;
    };

    _proto.exportChart = function exportChart(mimeType, onExported) {
      if (!this.chart) {
        // eslint-disable-next-line no-console
        return console.error('No chart is available to export.');
      }

      this.chart.export(mimeType, onExported);
    };

    _proto.loadData = function loadData(data) {
      if (!this.chart) {
        // eslint-disable-next-line no-console
        return console.error('No chart is available to which data can be loaded. It may already have been destroyed, or has never been drawn.');
      }

      this.chart.load(data);
    };

    _proto.redraw = function redraw() {
      if (!this.chart) {
        // eslint-disable-next-line no-console
        return console.error('No chart is available to draw.');
      }

      this.chart.flush();
    };

    _proto.setChart = function setChart(data) {
      if (this.chart) {
        this.loadData(data);
      } else {
        var _this$props = this.props;
            _this$props.className;
            _this$props.domProps;
            _this$props.isPure;
            _this$props.style;
            _this$props.unloadBeforeLoad;
            var config = _objectWithoutPropertiesLoose(_this$props, ["className", "domProps", "isPure", "style", "unloadBeforeLoad"]);

        this.chart = billboard_js.bb.generate(_extends({
          bindto: this.chartElement
        }, config));
      }
    };

    _proto.setChartElementRef = function setChartElementRef(element) {
      this.chartElement = element;
    };

    _proto.unloadData = function unloadData(data) {
      if (!this.chart) {
        // eslint-disable-next-line no-console
        return console.error('No chart is available from which data can be unloaded. It may already have been destroyed, or has never been drawn.');
      }

      this.chart.unload(data);
    };

    _proto.updateChart = function updateChart() {
      var _this$props2 = this.props,
          data = _this$props2.data,
          unloadBeforeLoad = _this$props2.unloadBeforeLoad;
      var dataToLoad = unloadBeforeLoad ? _extends({}, data, {
        unload: true
      }) : data;
      this.setChart(dataToLoad);
    };

    _proto.updateConfig = function updateConfig(name, value, redraw) {
      if (!this.chart) {
        // eslint-disable-next-line no-console
        return console.error('You are trying to set the config a chart that does not exist.' + 'Have you passed `data`?');
      }

      return this.chart.config(name, value, redraw);
    };

    _proto.render = function render() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          domProps = _this$props3.domProps,
          style = _this$props3.style;
      return /*#__PURE__*/React__default['default'].createElement("div", _extends({
        className: className,
        style: style
      }, domProps, {
        ref: this.setChartElementRef
      }));
    };

    return BillboardChart;
  }(React__default['default'].Component);

  _defineProperty(BillboardChart, "displayName", 'BillboardChart');

  _defineProperty(BillboardChart, "propTypes", propTypes);

  _defineProperty(BillboardChart, "getInstances", function () {
    return billboard_js.bb.instance;
  });

  exports.default = BillboardChart;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=react-billboardjs.js.map
